const userAgent = navigator.userAgent.toLowerCase();

export const FIREFOX_LINE_SEPARATOR = '\n';
export const CHROME_LINE_SEPARATOR = '\r\n';
export const LINE_SEPARATOR = ((userAgent.indexOf('firefox') > -1) || (userAgent.indexOf('edge') > -1))
  ? FIREFOX_LINE_SEPARATOR : CHROME_LINE_SEPARATOR;

export const fixLineSeparatorForBrowser = (stringWithCarriageReturnAndNewLines) => {
  if((userAgent.indexOf('firefox') > -1) || (userAgent.indexOf('edge') > -1)) {
    return stringWithCarriageReturnAndNewLines.replace(/\r\n/g,'\n');
  }
  return stringWithCarriageReturnAndNewLines;
};
